import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MobileSm, DefaultSm } from 'components/MediaQueries';
import APDropdown from 'components/Dropdown/APDropdown';
import Drawer from 'components/Drawer';
import './styles.scss';

/**
 * @description: AP Responsive Dropdown -- changes to drawer in mobile.
 * @param {*}
 * @return {*}
 */
const APResponsiveDropdown = ({
  opened,
  show,
  dismiss,
  triggerButton,
  anchorElement,
  children,
  placement,
  hasArrow,
  className,
  menuClass,
  drawerPosition = 'bottom',
  backdrop = true,
  scrollLockOnOpen = true,
  adjustOnVerticalOverflow = true,
  root,
}) => {
  return (
    <>
      <DefaultSm>
        <div
          className={clsx('ap-responsive-dropdown', 'ap-responsive-dropdown--desktop', className)}
        >
          <APDropdown
            isOpen={opened}
            show={show}
            dismiss={dismiss}
            onClick={show}
            triggerButton={triggerButton}
            anchorElement={anchorElement}
            placement={placement}
            hasArrow={hasArrow}
            menuClass={menuClass}
            backdrop={backdrop}
            scrollLockOnOpen={scrollLockOnOpen}
            adjustOnVerticalOverflow={adjustOnVerticalOverflow}
            root={root}
          >
            {children}
          </APDropdown>
        </div>
      </DefaultSm>
      <MobileSm>
        <div
          className={clsx('ap-responsive-dropdown', 'ap-responsive-dropdown--mobile', className)}
        >
          <Drawer
            isOpen={opened}
            show={show}
            dismiss={dismiss}
            position={drawerPosition}
            triggerButton={triggerButton}
            menuClass={menuClass}
          >
            {children}
          </Drawer>
        </div>
      </MobileSm>
    </>
  );
};

APResponsiveDropdown.propTypes = {
  opened: PropTypes.bool,
  dismiss: PropTypes.func,
  triggerButton: PropTypes.node,
  children: PropTypes.node,
  placement: PropTypes.string,
  hasArrow: PropTypes.bool,
  drawerPosition: PropTypes.string,
  backdrop: PropTypes.bool,
  scrollLockOnOpen: PropTypes.bool,
  adjustOnVerticalOverflow: PropTypes.bool,
  className: PropTypes.string,
};

APResponsiveDropdown.defaultProps = {
  scrollLockOnOpen: false,
  adjustOnVerticalOverflow: true,
  drawerPosition: 'bottom',
  backdrop: true,
};

export default APResponsiveDropdown;
